import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useScrollLock } from "../../hooks/useScrollLock";

import {
  ModalOverlay,
  ModalContainer,
  ModalContent,
  ModalTitle,
  NoticeList,
  NoticeItem,
  NoticeEmoji,
  NoticeText,
  FooterText,
  TitleContainer,
  ContinueButton,
  LogoImg,
} from "./TermsModal.styles";

const TermsModal = ({ isOpen, onClose }) => {
  const [shouldRender, setShouldRender] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useScrollLock(shouldRender);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      setIsAnimating(false);
      const timer = requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setIsAnimating(true);
        });
      });
      return () => cancelAnimationFrame(timer);
    } else if (shouldRender) {
      setIsAnimating(false);
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen, shouldRender]);

  if (!shouldRender) return null;

  return createPortal(
    <ModalOverlay $isAnimating={isAnimating}>
      <ModalContainer $isAnimating={isAnimating}>
        <ModalContent>
          <TitleContainer>
            <LogoImg src="/logos/fapify.webp" alt="Fapify" />

            <ModalTitle>Welcome</ModalTitle>
          </TitleContainer>

          <NoticeList>
            <NoticeItem $delay="0.1s">
              <NoticeEmoji>🔞</NoticeEmoji>
              <NoticeText>You must be 18+ to use this website.</NoticeText>
            </NoticeItem>
            <NoticeItem $delay="0.18s">
              <NoticeEmoji>📌</NoticeEmoji>
              <NoticeText>
                You can't use others people's photos without their permission.
              </NoticeText>
            </NoticeItem>
            <NoticeItem $delay="0.26s">
              <NoticeEmoji>🧑‍⚖️</NoticeEmoji>
              <NoticeText>
                You are solely responsible for the videos and images you
                generate.
              </NoticeText>
            </NoticeItem>
          </NoticeList>

          <FooterText>
            By continuing to use, you agree to the rules above.
          </FooterText>

          <ContinueButton onClick={onClose}>Continue</ContinueButton>
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>,
    document.body,
  );
};

export default TermsModal;
